import { type QueryClient } from '@tanstack/react-query';
import { queryKeys } from 'queryKeys';

import { authSessionStore } from './store';

let initialized = false;

export function initAuthSessionQuerySync(queryClient: QueryClient): void {
  if (initialized) {
    return;
  }

  initialized = true;

  const sync = () => {
    const snapshot = authSessionStore.getSnapshot();
    queryClient.setQueryData(queryKeys.auth.session(), snapshot);
    queryClient.setQueryData(queryKeys.auth.user(), snapshot.user ?? undefined);
    queryClient.setQueryData(queryKeys.auth.token(), snapshot.tokens);
  };

  sync();
  authSessionStore.subscribe(sync);
}
